export default __webpack_public_path__ + "static/media/521.15908dc0.png";